const AccessOrNot = (feature) => {
    let user_plan = localStorage.getItem("planid")
    let features = {
      "story_automation":["566420","566422","566423","428337","428338","000003","0000031","201","2011","202","2021","203","2031","204","2041"],
      "next_post_automation":["566422","566423","428337","428338","000003","0000031","202","2021","203","2031","204","2041"],
      "copy_previous_post": ["566422","566423","428337","428338","000003","0000031","201","2011","202","2021","203","2031","204","2041"],
      "all_comment": ["566420","566421","566422","566423","428337","428338","000003","0000031","202","2021","203","2031","204","2041"],
      "post_dm": ["428337","428338","202","2021","203","2031","204","2041"],
      "smart_mode": ["428337","428338","000003","0000031","202","2021","203","2031","204","2041"], 
      "welcome_message":["566420","566421","566422","566423","428337","428338","000003","0000031","201","2011","202","2021","203","2031","204","2041"],
      "follow_only":["566422","566423","428337","428338","000003","0000031","202","2021","203","2031","204","2041"],
      "button_template":["566422","566423","428337","428338","000003","0000031","202","2021","203","2031","204","2041"],
      "reply_delay":["566420","566421","566422","566423","428337","428338","000003","0000031","201","2011","202","2021","203","2031","204","2041"],
      "flow_editor": ["5052712","566422","566423","428337","428338","000003","0000031","202","2021","203","2031","204","2041"],
    }
    // console.log("=========" , (features[feature] || []) , user_plan)

    if ((features[feature] || []).includes(user_plan)){
      return true
    }
    else{
      return false
    }
      
  }

  export default AccessOrNot;